import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface CoreInsightsProps {
    data?: string;
}

export const CoreInsights = ({ data }: CoreInsightsProps) => {
    if (!data) return null;

    return (
        <div className="mb-6 mx-5 bg-white p-10">
            <h2 className="text-center text-[#187A85] text-2xl font-bold mb-4">Core Insights</h2>

            <div className="bg-[#FFF9F2] p-6 rounded-lg text-sm text-[#333333] leading-relaxed insights-content">
                <style>{`
                    .insights-content h1 {
                        font-size: 20px;
                        color: #187A85;
                        margin-bottom: 12px;
                        font-weight: 700;
                        line-height: 1.4;
                    }
                    .insights-content h2 {
                        font-size: 16px;
                        color: #187A85;
                        margin-top: 24px;
                        margin-bottom: 8px;
                        font-weight: 700;
                    }
                    .insights-content h3 {
                        font-size: 15px;
                        color: #187A85;
                        margin-top: 16px;
                        margin-bottom: 8px;
                        font-weight: 700;
                    }
                    .insights-content p { margin-bottom: 12px; }
                    .insights-content ul { margin-left: 20px; list-style-type: disc; margin-bottom: 12px; }
                    .insights-content li { margin-bottom: 4px; }
                    .insights-content strong { color: #000000; font-weight: 700; }
                `}</style>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{data}</ReactMarkdown>
            </div>
        </div>
    );
};
